import React from "react";
import { motion } from "framer-motion";

export default function ServiceCard({ icon, title, description, delay = 0 }) {
  return (
    <motion.div
      className="service-card"
      data-aos="fade-up"
      data-aos-delay={delay}
      whileHover={{ 
        scale: 1.05,
        y: -10,
        boxShadow: "0 25px 50px rgba(0, 212, 255, 0.3)"
      }}
      whileTap={{ scale: 0.98 }}
      initial={{ opacity: 0, rotateX: -15 }}
      whileInView={{ opacity: 1, rotateX: 0 }}
      viewport={{ once: true }}
      transition={{ 
        type: "spring",
        stiffness: 200,
        damping: 15
      }}
    >
      <motion.div 
        className="service-icon"
        whileHover={{ 
          rotate: [0, -10, 10, -10, 0],
          scale: 1.2
        }}
        transition={{ duration: 0.5 }}
      >
        {icon}
      </motion.div>
      <h3>{title}</h3>
      <p>{description}</p>
    </motion.div>
  );
}
